import { z } from 'zod';

/**
 * A **direct**, per-user permission assignment (N8):
 *
 * - `grant` — the narrow-job hire: one permission handed to someone without
 *   inventing a role for them;
 * - `deny` — the carve-out: one permission (or a wildcard's worth) taken away
 *   from someone who otherwise holds a broad role. This is the case
 *   roles-alone RBAC cannot express, and it is why deny wins (N22).
 */
export const PERMISSION_EFFECTS = ['grant', 'deny'] as const;

export const PermissionEffectSchema = z.enum(PERMISSION_EFFECTS);

export type PermissionEffect = (typeof PERMISSION_EFFECTS)[number];
